// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/trash.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.applications-container {
  display: flex;
  justify-content: flex-start;
  height: 350px;
  overflow: auto;
  flex-direction: column;
  align-content: flex-start;
  align-items: stretch;
  padding-right: 30px;
}

.applications-card {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.applications-card:first-child {
  margin-top: 50px;
}
.applications-card img {
  width: 70px;
  height: 70px;
}

.applications-image {
  width: 90px;
}

.applications-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.applications-remove {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.applications-row {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.applications-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.applications-content .form-group {
  margin-bottom: 0px;
}

.applications-content .form-group label {
  color: #141718;
}

.applications-name {
  display: flex;
  flex: 1 1;
}

.applications-name .user-name {
  font-weight: 600;
}

.applications-login {
  display: flex;
  justify-content: flex-end;
  font-weight: 100;
  font-size: 12px;
  flex: 1 1;
}

.applications-admin {
  margin-left: 10px;
  background-color: #ff97e8;
  color: #141718;
}

body .applications-login button {
  font-size: 14px;
  font-weight: 600;
  padding: 12px 16px;
  border-radius: 12px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Applications/applications.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,mDAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,qBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AADF;;AAIA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AADF","sourcesContent":[".applications-container {\n  display: flex;\n  justify-content: flex-start;\n  height: 350px;\n  overflow: auto;\n  flex-direction: column;\n  align-content: flex-start;\n  align-items: stretch;\n  padding-right: 30px;\n}\n\n.applications-card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n\n  &:first-child {\n    margin-top: 50px;\n  }\n\n  img {\n    width: 70px;\n    height: 70px;\n  }\n}\n\n.applications-image {\n  width: 90px;\n}\n\n.applications-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.applications-remove {\n  background: url(\"../../Assets/Images/trash.png\");\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.applications-row {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.applications-content h4 {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.applications-content .form-group {\n  margin-bottom: 0px;\n}\n\n.applications-content .form-group label {\n  color: #141718;\n}\n\n.applications-name {\n  display: flex;\n  flex: 1;\n}\n\n.applications-name .user-name {\n  font-weight: 600;\n}\n\n.applications-login {\n  display: flex;\n  justify-content: flex-end;\n  font-weight: 100;\n  font-size: 12px;\n  flex: 1;\n}\n\n.applications-admin {\n  margin-left: 10px;\n  background-color: #ff97e8;\n  color: #141718;\n}\n\nbody .applications-login button {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 12px 16px;\n  border-radius: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
